import { useCMSPage } from "../../../context/CMSContext";

const DEFAULT_PARAGRAPHS = [
  "Cleario launched in 2025 with two vans and a single promise: treat people's homes like your own.",
  "We grew fast because we kept it simple — show up on time, take what we say we will, leave the place tidy, and charge a fair price.",
];

const DEFAULT_MILESTONES = [
  { year: "2025", icon: "ri-truck-line",        title: "Started with one van, one promise",       desc: "One van, one region, one rule: every load disposed of properly." },
  { year: "2025", icon: "ri-map-2-line",         title: "Covering the West Midlands",              desc: "Expanded to Birmingham, Solihull, Droitwich, Bromsgrove and Redditch." },
  { year: "2025", icon: "ri-shield-check-line",  title: "Every employee DBS checked & vetted",     desc: "Directly employed, background checked, fully vetted — non-negotiable." },
  { year: "2026", icon: "ri-heart-line",         title: "Make-A-Wish Foundation milestone",        desc: "Thousands of donations to Make-A-Wish, one for every collection completed." },
  { year: "2026", icon: "ri-calendar-check-line",title: "Same-day is the new standard",            desc: "Fixed pricing, digital waste notes, 95%+ recycled — every job." },
];

export default function AboutStory() {
  const { data: aboutCMS } = useCMSPage("about");
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const storyCMS: any = (aboutCMS as any)?.story ?? {};

  const headline   = storyCMS?.headline    ?? "How it started.";
  const paragraphs: string[] = storyCMS?.paragraphs?.length ? storyCMS.paragraphs : DEFAULT_PARAGRAPHS;
  const image      = storyCMS?.image       || "";

  return (
    <section className="py-20 bg-white">
      <div className="max-w-screen-xl mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-start">

          {/* Left copy */}
          <div>
            <div className="inline-flex items-center gap-2 bg-cl-lime rounded-full px-4 py-1.5 mb-5 thick-border cartoon-shadow-sm">
              <span className="text-cl-dark text-xs font-black uppercase tracking-widest">Our Journey</span>
            </div>
            <h2 className="text-4xl md:text-5xl font-black text-cl-dark leading-tight mb-6">{headline}</h2>
            <div className="flex flex-col gap-4 mb-8">
              {paragraphs.map((p, i) => (
                <p key={i} className="text-cl-dark/70 text-base font-semibold leading-relaxed">{p}</p>
              ))}
            </div>

            {image && (
              <img
                src={image}
                alt="Cleario story"
                className="w-full rounded-2xl object-cover h-52 cartoon-card"
              />
            )}
          </div>

          {/* Right — milestone timeline */}
          <div className="flex flex-col gap-0 relative">
            <div className="absolute left-5 top-8 bottom-8 w-0.5 bg-cl-lime/40 z-0"></div>
            {DEFAULT_MILESTONES.map((m, i) => (
              <div key={i} className="relative flex gap-6 pb-8 last:pb-0 z-10">
                <div className="flex flex-col items-center flex-shrink-0">
                  <span className="w-10 h-10 flex items-center justify-center rounded-full bg-cl-lime border-2 border-cl-dark cartoon-shadow-sm">
                    <i className={`${m.icon} text-cl-dark text-base`}></i>
                  </span>
                </div>
                <div className="pt-1.5">
                  <span className="text-cl-green font-black text-xs uppercase tracking-widest mb-0.5 block">{m.year}</span>
                  <h3 className="font-black text-cl-dark text-base mb-1 leading-tight">{m.title}</h3>
                  <p className="text-cl-dark/60 text-sm font-semibold leading-relaxed">{m.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
